import printTickets from './printTickets';
import { filterCommandsByItemRef } from './PrintTicketsAtb.utils';
import GENERATE_PRINT_COMMANDS_QUERY from './printCommandQuery';

const PrintAtb = async (obj, { bookingReference, itemRefs }, { client }) => {
  const { data, error } = await client.query({
    query: GENERATE_PRINT_COMMANDS_QUERY,
    variables: { bookingReference },
    fetchPolicy: 'network-only'
  });

  if (error) {
    throw error;
  }

  const printCommands = filterCommandsByItemRef(itemRefs, data.generatePassengerPrintCommands);

  return printTickets(printCommands);
};

export default PrintAtb;
